const defaultOptions = {
  colorSlice: "#00a1ff",
  fontColor: "#000",
  fontSize: "1.6rem",
  fontWeight: 400,
  lineargradient: false,
  number: true,
  round: false,
  fill: "none",
  unit: "%",
  rotation: -90,
  size: 200,
  stroke: 10,
};

export default defaultOptions;
